import { Box, Button, Form, Icon, Level, Section } from 'react-bulma-components';
import React, { useEffect, useRef, useState } from 'react';
import { faCopy, faLink, faSave, faTrash, faUnlink } from '@fortawesome/free-solid-svg-icons';

import Collapsible from '../components/collapsible';
import { Draggable } from 'react-smooth-dnd';
import Exercise from '../containers/exercise';
import ExerciseEditForm from '../components/exercise-edit-form';
import Finder from '../containers/finder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import KeyTonicPicker from '../components/keytonic-picker';
import Switch from '../components/switch';

const { Control, Field, Label } = Form;

const SortablePracticeStackItem = ({ item, index, statePrefix, handleChange, handleDeletePractice, skipInstrumentTransponation }) => {
  const exerciseRef = useRef();
  const [showFinder, setShowFinder] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const [orgItem, setOrgItem] = useState({
    title: item.title,
    description: item.description,
    keytonic: item.keytonic
  });
  const [stackItemTitle, setStackItemTitle] = useState(item.title);
  useEffect(() => {
    setStackItemTitle(item.title);
  }, [item]);

  const handleUnlinkExercise = (index) => {
    var fieldParent = `${statePrefix}[${index}]`;
    var e = new Object();
    e.target = {
      name: `${fieldParent}.title`,
      value: orgItem.title
    };
    handleChange(e);
    e.target = {
      name: `${fieldParent}.description`,
      value: orgItem.description
    };
    handleChange(e);
    e.target = {
      name: `${fieldParent}.refid`,
      value: null
    };
    handleChange(e);
    setStackItemTitle(item.title);
    /*     e.target = {
          name: `${fieldParent}.title`,
          value: "Practice title"
        };
        handleChange(e); */
  }

  const handleExerciseChange = (e) => {
    if(e.target.name.endsWith('.title')){
      setStackItemTitle(e.target.value);
    }

    if(e.target.name.endsWith('.allowUserKey')){
      handleChange(e, "Boolean");
    }
    else{
      handleChange(e);
    }
  }

  const handleCopyExercise = (index) => {
    var exc = exerciseRef.current.getExercise();
    if (exc) {
      var fieldParent = `${statePrefix}[${index}]`;
      var e = new Object();
      e.target = {
        name: `${fieldParent}.title`,
        value: exc.title
      };
      handleChange(e);
      e.target = {
        name: `${fieldParent}.description`,
        value: exc.description
      };
      handleChange(e);
      e.target = {
        name: `${fieldParent}.refid`,
        value: null
      };
      handleChange(e);
      setStackItemTitle(exc.title);

    }
  }

  const getFile = () => {
    return item;
  }


  const onLinkItemSelect = (item) => {
    if (item.kind != "exc") {
      return;
    }
    var fieldParent = `${statePrefix}[${index}]`;
    setStackItemTitle(item.name);
    var e = new Object();
    e.target = {
      name: `${fieldParent}.title`,
      value: item.name
    };
    handleChange(e);
    e.target = {
      name: `${fieldParent}.description`,
      value: ""
    };
    handleChange(e);
    e.target = {
      name: `${fieldParent}.refid`,
      value: item.id
    };
    handleChange(e);
    setShowFinder(false);
  }

  return (
    <Draggable key={item.id}>
      <Box style={{ backgroundColor: "white", border: "1px solid lightgrey" }} className="draggable-item">
        <Collapsible>
          <Collapsible.Item key={item.id ? item.id : item.collapsibleid}>
            <Collapsible.Summary id={item.id ? item.id : item.collapsibleid} style={{ color: "#3273dc", cursor: "pointer" }}>
              <span className="column-drag-handle" style={{ float: 'left', padding: '0 10px', cursor: 'move' }}>&#x2630;</span>
              {stackItemTitle}{item.refid && <>&nbsp;<FontAwesomeIcon color={"lightBlue"} icon={faLink} /></>}
              <span style={{ float: 'right', padding: '0 10px', cursor: 'pointer', color: "#f14668" }}>

                <Button
                  size="small"
                  onClick={() => {
                    handleDeletePractice(index)
                  }
                  }>
                  <Icon color="danger"><FontAwesomeIcon icon={faTrash} /></Icon>
                </Button>

              </span>
            </Collapsible.Summary>
            <Collapsible.Content>

              {item.refid ?
                <>
                  <Button
                    size="small"
                    onClick={() => {
                      handleUnlinkExercise(index)
                    }
                    }>
                    <Icon><FontAwesomeIcon icon={faUnlink} /></Icon>
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      handleCopyExercise(index)
                    }
                    }>
                    <Icon><FontAwesomeIcon icon={faCopy} /></Icon>
                  </Button>
                </>
                :
                <>

                  <Button
                    size="small"
                    onClick={() => {
                      setShowSave(setShowFinder(!showFinder));
                    }
                    }>
                    <Icon><FontAwesomeIcon icon={faLink} /></Icon>
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      setShowFinder(setShowSave(!showSave));
                    }
                    }>
                    <Icon color="info"><FontAwesomeIcon icon={faSave} /></Icon>
                  </Button>
                  {showSave &&
                    <Section>
                      <Field>
                        <Label>Pick a folder location and choose Add File:</Label>
                        <Finder rootFolder="Excercises" fileName={stackItemTitle} getFileOnAdd={getFile} onSaved={onLinkItemSelect} />
                        <br />
                      </Field>
                    </Section>
                  }
                  {showFinder &&
                    <Section>
                      <Field>
                        <Label>Pick an exercise:</Label>
                        <Finder onItemSelect={onLinkItemSelect} rootFolder="Excercises" />
                      </Field>
                    </Section>
                  }
                </>
              }
              <br />
              {item.refid ?
                <>
                  <Field>
                    <Control>
                      <Label>Key tonic:</Label>
                      <Level>
                        <Level.Side align="left">
                          <Level.Item>
                            <KeyTonicPicker name={`${statePrefix}[${index}].keytonic`} onChange={handleChange} value={item.keytonic} />
                            <Switch name={`${statePrefix}[${index}].allowUserKey`} label={'Allow user to change key'} checked={item.allowUserKey ?? false} onChange={(e) => handleChange(e, "Boolean")} />
                          </Level.Item>
                        </Level.Side>
                      </Level>
                    </Control>
                  </Field>
                  <Label>Preview</Label>
                  <Exercise ref={exerciseRef} id={item.refid} keytonic={item.keytonic} allowUserKey={item.allowUserKey ?? false} skipInstrumentTransponation={skipInstrumentTransponation} isPreview={true} />
                </>
                :
                <>
                  <ExerciseEditForm statePrefix={`${statePrefix}[${index}].`} item={item} allowUserKey={item.allowUserKey ?? false} handleChange={handleExerciseChange} skipInstrumentTransponation={skipInstrumentTransponation}/>
                </>
              }
            </Collapsible.Content>
          </Collapsible.Item>

        </Collapsible>
      </Box>
    </Draggable>
  )
};

export default SortablePracticeStackItem;